import {AbstractSelectEditControlComponent} from "./abstract-select-edit-control.component";
import {Directive, Injector, Input, ViewChild} from "@angular/core";
import {MultiSelectControlComponent} from "../../../select/multi-select-control.component";
import {SearchModel} from "@fedeltapointofsale/data-client";

/**
 * Abstract class that implements methods for the multi-select edit inputs
 */
@Directive()
export class AbstractMultiSelectEditControlComponent <T extends SearchModel<any>> extends AbstractSelectEditControlComponent<T> {
    @Input() multiObjectValueType: boolean;
    @Input() pillRemovable: boolean = true;
    @Input() showSelections: boolean = true;

    /**
     * Function that validates if an item should be shown. allow the multi select to work with a partial list of values while keeping the full list.
     */
    @Input() viewFilter: (item: any) => boolean;

    @ViewChild(MultiSelectControlComponent) selectControlComponent: MultiSelectControlComponent;

    constructor(model: T, injector: Injector, valueField?: string, labelField?: string, protected overrideOpenView: boolean = false) {
        super(model, injector, valueField, labelField);
    }

    click() {
        this.selectControlComponent.click();
    }

    focus() {
        this.selectControlComponent.focus();
    }
}
